export enum enumIsfState {
  NOT_SENT = 0,
  DRAFT_CBY_V_SEND = 100,
  VALIDATED_AT_PROVIDER = 200,
  BOND_PENDING = 260,
  NOT_VALID_AT_PROVIDER = 300,
  PROVIDER_SEND_PENDING = 400,
  DRAFT_CBP_PEND = 500,
  ACCEPTED_CBP = 600,
  NO_BILL_ON_FILE = 655,
  BILL_TYPE_NOT_MATCHED = 660,
  APPROVED = 700,
  REJECTED_CBP = 800,
  CBP_DELETE_PENDING = 900,
  CBP_DELETED = 950,
  DELETED = 1000,
  CUSTOM = 5000,
  UNRECOVERABLE = 10000,
}
